<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import axios from 'axios';
import { formatSanDiegoDateTime } from '../utils/dateTime';

const route = useRoute();
const donation = ref(null);
const groupedItems = ref({});

const allowedCategories = [
  'Requested_Product',
  'Product_For_Reallocation',
  'Product_On_Hand',
  'Donation_Info',
  'Delivered_Product',
  'Actually_Reallocated'
];

function getAuthHeaders() {
  const token = sessionStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function formatCategoryName(cat) {
  return cat.replace(/_/g, ' ');
}

function cleanName(name) {
  if (!name) return '';

  let cleaned = name.replace(/^#_of_/, '');

  const parts = cleaned.split('_');

  parts.pop();

  return parts.join(' ');
}


function formatDate(dateStr) {
  return formatSanDiegoDateTime(dateStr);
}

onMounted(async () => {
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_API_URL}/api/donations/${route.params.code}`,
      { headers: getAuthHeaders() }
    );
    donation.value = data.donation;

    const grouped = {};
    data.items.forEach(item => {
      const cat = item.category;
      if (!allowedCategories.includes(cat)) return;
      if (!grouped[cat]) grouped[cat] = [];
      grouped[cat].push(item);
    });
    groupedItems.value = grouped;
  } catch (err) {
    console.error('Failed to load donation detail:', err);
  }
});
</script>
<template>
  <div v-if="donation" class="text-center mx-auto" style="max-width: 600px;">
    <h2>Request {{ donation.unique_qr_code }}</h2>
    <p>By {{ donation.submitted_by }}</p>

    <p>Status: {{ donation.submission_status }}</p>
    <p>Location: {{ donation.location }}</p>
    <p>Date Submitted: {{ formatDate(donation.created_at) }}</p>
    <p v-if="donation.comments">Comments: {{ donation.comments }}</p>

    <h3 class="mt-4">Items</h3>
    <div v-for="(items, cat) in groupedItems" :key="cat" class="mb-3">
      <h5>{{ formatCategoryName(cat) }}</h5>
      <div class="list-group">
        <div v-for="item in items" :key="item.donation_item_id"
          class="list-group-item d-flex justify-content-between align-items-center">
          <div class="text-start w-100">
            <div class="fw-semibold">
              {{ cleanName(item.category_name) }} - {{ item.bin_type }}
            </div>
            <div class="text-muted small">
              Requested: {{ item.quantity }} • Delivered: {{ item.delivered_quantity }}
              <span v-if="item.fulfilled > 0"> • Fulfilled: {{ item.fulfilled }}</span>
              <span v-else-if="item.already_delivered > 0">
                • Still Requesting: {{ item.quantity - item.delivered_quantity }}
              </span>
            </div>
          </div>

          <span class="badge rounded-pill border px-3" :class="{
            'bg-success text-light': item.fulfilled > 0,
            'bg-warning text-dark': item.already_delivered > 0,
            'bg-secondary text-light': item.delivered_quantity === 0
          }">
            {{ item.fulfilled > 0 ? 'Fulfilled' : item.already_delivered > 0 ? 'Partial' : 'Pending' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>